var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"group-title"}},[_c('span',[_vm._v(_vm._s(_vm.title || ' '))]),_vm._v(" "),_c('div',{attrs:{"id":"info-icon"}},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-075d1ecd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Context/GroupTitle.vue
// module id = null
// module chunks = 